//Import Images
import athlete from "./img/athlete-small.png";
import goodtimes from "./img/goodtimes-small.png";
import theracer from "./img/theracer-small.png";
import athlete2 from "./img/athlete2.png";
import goodtimes2 from "./img/good-times2.jpg";
import theracer2 from "./img/the-racer2.jpg";
import two from "./img/2.jpg";
import three from "./img/3.jpg";
import four from "./img/4.jpg";
import five from "./img/5.jpg";
import six from "./img/6.jpg";
import seven from "./img/7.jpg";
import eight from "./img/8.jpg";
import nine from "./img/9.jpg";
import ten from "./img/10.jpg";
import eleven from "./img/11.jpg";
import twelve from "./img/12.jpg";
import thirteen from "./img/13.jpg";
import fourteen from "./img/14.jpg";
import fifteen from "./img/15.jpg";
import sixteen from "./img/16.jpg";
import seventeen from "./img/17.jpg";
import eighteen from "./img/18.jpg";
import nineteen from "./img/19.jpg";
import twenty from "./img/20.jpg";
import twentyone from "./img/21.jpg";

export const MovieState = () => {
  return [
    {
      title: "Face of Life 03",
      mainImg: two,
      secondaryImg: two,
      url: "/work/face-of-life-03",
      awards: [

      ],
    },
    {
      title: "Face of Life 59",
      mainImg: three,
      url: "/work/face-of-life-59",
      secondaryImg: three,
      awards: [

      ],
    },
    {
      title: "Face Of Life 71",
      mainImg: four,
      url: "/work/face-of-life-71",
      secondaryImg: four,
      awards: [

      ],
    },
    {
      title: "Power Recycling",
      mainImg: five,
      url: "/work/power-recycling",
      secondaryImg: five,
      awards: [

      ],
    },
    {
      title: "Power 7,8",
      mainImg: six,
      url: "/work/power-7-8",
      secondaryImg: six,
      awards: [

      ],
    },
    {
      title: "Power 9,10,11",
      mainImg: seven,
      url: "/work/power-9-10-11",
      secondaryImg: seven,
      awards: [

      ],
    },
    {
      title: "Power 13",
      mainImg: eight,
      url: "/work/power-13",
      secondaryImg: eight,
      awards: [

      ],
    },
    {
      title: "Brutal Power",
      mainImg: nine,
      url: "/work/power-16",
      secondaryImg: nine,
      awards: [

      ],
    },
    {
      title: "The Last Result",
      mainImg: ten,
      url: "/work/last-result",
      secondaryImg: ten,
      awards: [

      ],
    },
    {
      title: "Dance After 110 Years",
      mainImg: eleven,
      url: "/work/dance-after-110-years",
      secondaryImg: eleven,
      awards: [

      ],
    },
    {
      title: "Behind The Scenes",
      mainImg: twelve,
      url: "/work/behind-the-scenes",
      secondaryImg: twelve,
      awards: [

      ],
    },
    {
      title: "Brihatta Home Art Project June-2020",
      mainImg: thirteen,
      url: "/work/brihatta-6-2020",
      secondaryImg: thirteen,
      awards: [

      ],
    },
    {
      title: "Brihatta Home Art Project July-2020",
      mainImg: fourteen,
      url: "/work/brihatta-7-2020",
      secondaryImg: fourteen,
      awards: [

      ],
    },
    {
      title: "Dance",
      mainImg: fifteen,
      url: "/work/dance",
      secondaryImg: fifteen,
      awards: [

      ],
    },
    {
      title: "Imagine",
      mainImg: sixteen,
      url: "/work/imagine",
      secondaryImg: sixteen,
      awards: [
        {
          title: "Story",
          description:
            `Day 1 of the 10 days!!!
            Thank you so much one of the most renowned and versatile artist of Bangladesh, Bishwajit Goswami dada for nominating me.
            
            Today I am nominating another very committed and talented emarging artist of Bangladesh , Shohrav Jahan.
            
            I am requesting you to upload 10 art works for 10 days and nominated 10 artists in a day.
            
            Art is a therapy for now in this pandemic days. I think this is a positive and powerful response to enlighten others and keeping our soul more meaningful.
            
            Title : Imagine
            2016, Mixed media (Bronze,acrylic, screen print)
            Size : 10.2 in x 15.3in x 63.4 in
            
            "Imagine " - John Lennon
            
            Imagine there's no heaven
            It's easy if you try
            No hell bellow us
            Above us only sky
            Imagine all the people
            Living for today... Aha-ah...
            
            Imagine there's no countries
            It isn’t hard to do
            Northing to kill or die for
            And no relegion, too
            Imagine all the people
            Living life in peace.....you..."
            
            The present time of the world in the true sense is no longer limited to the imagination. Now all the people are under house arrest. Many are starving and helpless. No relegion, no caste, no rich-poor discrimination. Corona has captured all people.
            
            It was a form of thinking when I did the work. But now l can see it's real form.`,
        },
        {
          title: "Amazing Artwork.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
        {
          title: "Magnificent.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
      ],
    },
    {
      title: "Brihatta Home Art Project 2020",
      mainImg: seventeen,
      url: "/work/brihatta-2020",
      secondaryImg: seventeen,
      awards: [

      ],
    },
    {
      title: "Puja",
      mainImg: eighteen,
      url: "/work/puja",
      secondaryImg: eighteen,
      awards: [

      ],
    },
    {
      title: "Rongbaaz",
      mainImg: nineteen,
      url: "/work/rongbaaz",
      secondaryImg: nineteen,
      awards: [
        {
          title: "Story",
          description:
            `Rongbaaz is a collective project by Britto in collaboration with Rickshaw & Banner painters
            Opening reception: 5.30 pm, 24 January 2020
            Venue: Britto Space
            Exhibition: 24 Jan - 15 Feb (everyday 1 - 8 pm)
            Britto has done a number of projects in collaboration with traditional artists,
            artisans and makers including rickshaw and cinema banner painters in past to
            create a new language in contemporary art practice.
            Rickshaw decoration and it’s painting have marked a new urban popular art
            form in Bangladesh. Similarly cinema banner painting with its unique style has
            become part of consistent public art for years in South Asia.
            *RONGBAAZ *addresses a popular urban art project inspired and influenced by
            the traditional rickshaw and cinema banner paintings. 8 contemporary artists
            in collaboration with 2 rickshaw / banner painters collectively did this project
            for two months at Britto and transformed the white cube gallery space to a
            public domain.
            -The word ‘RONGBAAZ’ is derived from a popular 1973 bengali film.
            Participants
            Aminul Islam Ashik
            Jewel A Rob
            Lutfun Nahar
            Mahbubur Rahman
            Shimul Dutta
            Shimul Saha
            Tayeba Begum Lipi
            Yasmin Jahan Nupur
            Mohammad Hanif Pappu (banner painter)
            Tapan Das (rickshaw painter)`,
        },
        {
          title: "Amazing Artwork.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
        {
          title: "Magnificent.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
      ],
    },
    {
      title: "জাতির জনক",
      mainImg: twenty,
      url: "/work/father-of-the-nation",
      secondaryImg: twenty,
      awards: [

      ],
    },
    {
      title: "ডিওরমা - নবাব নুসরাত জং এর দরবার-3",
      mainImg: twentyone,
      url: "/work/nusrat-03",
      secondaryImg: twentyone,
      awards: [
        {
          title: "Association",
          description:
            `ডিওরমা - নবাব নুসরাত জং এর দরবার। এশিয়াটিক সোসাইটি ঐতিহ্য জাদুঘর, নিমতলী দেউড়ি।
            বাস্তবায়ন -বাংলাদেশ এশিয়াটিক সোসাইটি। 
            বাস্তবায়ন সমন্বয়ক -  RedPixel Communications, 
            শিল্পী শুভ্র বাড়ৈ, শিল্পী নাসির উদ্দিন আহম্মেদ খান। 
            প্রধান শিল্পী -আমিনুল ইসলাম আশিক।`,
        },
        {
          title: "Amazing Artwork.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
        {
          title: "Magnificent.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
      ],
    },
  ];
};
